import React from 'react';

type Variant = 'trip' | 'booking' | 'parcel' | 'withdrawal' | 'payment';

interface Props {
  variant: Variant;
  status: string;
}

interface Tone {
  bg: string;
  text: string;
  dot: string;
}

const TONES: Record<string, Tone> = {
  sky:     { bg: 'bg-sky-100',     text: 'text-sky-800',     dot: 'bg-sky-500' },
  amber:   { bg: 'bg-amber-100',   text: 'text-amber-800',   dot: 'bg-amber-500' },
  indigo:  { bg: 'bg-indigo-100',  text: 'text-indigo-800',  dot: 'bg-indigo-500' },
  emerald: { bg: 'bg-emerald-100', text: 'text-emerald-800', dot: 'bg-emerald-500' },
  teal:    { bg: 'bg-teal-100',    text: 'text-teal-800',    dot: 'bg-teal-500' },
  rose:    { bg: 'bg-rose-100',    text: 'text-rose-800',    dot: 'bg-rose-500' },
  slate:   { bg: 'bg-slate-100',   text: 'text-slate-700',   dot: 'bg-slate-400' },
};

const TONE_MAP: Record<Variant, Record<string, keyof typeof TONES>> = {
  trip: {
    scheduled:  'sky',
    boarding:   'amber',
    in_transit: 'indigo',
    completed:  'emerald',
    cancelled:  'rose',
  },
  booking: {
    pending:  'amber',
    paid:     'emerald',
    refunded: 'slate',
  },
  parcel: {
    received:   'sky',
    in_transit: 'indigo',
    arrived:    'amber',
    delivered:  'teal',
    picked:     'emerald',
    cancelled:  'rose',
  },
  withdrawal: {
    pending:   'amber',
    approved:  'sky',
    rejected:  'rose',
    submitted: 'indigo',
    processed: 'emerald',
    failed:    'rose',
  },
  payment: {
    pending:  'amber',
    paid:     'emerald',
    refunded: 'slate',
  },
};

const StatusBadge: React.FC<Props> = ({ variant, status }) => {
  const toneKey = TONE_MAP[variant][status] ?? 'slate';
  const tone = TONES[toneKey];
  const label = status.replace(/_/g, ' ');

  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-semibold capitalize ${tone.bg} ${tone.text}`}
    >
      <span className={`h-1.5 w-1.5 rounded-full ${tone.dot}`} aria-hidden />
      {label}
    </span>
  );
};

export default StatusBadge;
